import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Corrected levels in the receiving room L’i",
  description: "Levels in the receiving room corrected due to influence of background noise are shown.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-11.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
